<template>
    <div v-if="visible" class="container" @click="onPress">
        <img class="img c1" src="https://app-test-1301744297.file.myqcloud.com/static/back_long.png" />
        <img class="img c2" src="https://app-test-1301744297.file.myqcloud.com/static/back_long.png" />

        <div  @touchmove.prevent class="p_title" draggable="false">
            <p class="contentText textTop">遇见有趣的人</p>
            <p class="contentText textBottom">聊情感的故事</p>

            <div class="divGap"></div>

            <img class="img_desc" src="../../assets/img_desc.png">
            <div class="button" id="buttonMiYou">
                <img class="img_button" src="../../assets/img_button.png">
            </div>
        </div>
    </div>
</template>


<script>
import { is_weixin, isIos, is_qq } from '../../common/functions';
// import Base64 from 'js-base64';
const Base64 = require('js-base64').Base64;

export default {
    data() {
        return {
            index: 1,
            visible: false,
        };
    },

    created() {
        document.title = "App下载";
        const query = window.location.search.substring(1);
        const vars = query.split('&');
        const now = Math.round((new Date()).getTime() / 1000);
        let isOutDate = false;

        try {
            // vars.forEach((item, i) => {
            //     if (item.search('identification=') != -1) {
            //         const arr = item.split('=');
            //         const data = arr[1];
            //         const par = Base64.decode(data);
            //         const t = par.split('&');
            //         t.forEach((entity, j) => {
            //             if (entity.search('time=') != -1) {
            //                 const h = entity.split('=');
            //                 const d = h[1];
            //                 const past = parseFloat(h[1]);
            //                 const duration = now - past;
            //                 isOutDate = duration > 3600;
            //                 // console.log('past duration duration - - - >', duration);
            //             }
            //         })
            //     }
            // })

            if (isOutDate) {
                window.location.pathname = '/out-date';
            } else {
                this.visible = true;
            }
        } catch (error) {
            this.visible = true;
        }
        
    },

    mounted() {
        // var data = OpenInstall.parseUrlParams();
        // new OpenInstall({
        //     appKey: 'anykqa',
        //     onready: function() {
        //         this.schemeWakeup();
        //         var m = this, button = document.getElementById('buttonMiYou');
        //         button.onclick = function() {

        //             if (is_weixin() && isIos()) {
        //                 alert('请点击右上角使用Safari浏览器打开后再进行下载!');
        //                 return false;
        //             } else {
        //                 m.wakeupOrInstall();
        //                 return false;
        //             }
                    
        //         }
        //     }
        // }, data);
    },

    methods: {
        onPress() {
            // console.log('on press si - - - - >');
            if (is_weixin() || is_qq()) {
                alert('请点击右上角使用外部浏览器打开后再进行下载!');
                return false;
            } else {
                const url = 'https://km-distribution-1301744297.file.myqcloud.com/xt_ks/xunta_share.apk';
                window.location.href = url;
                return false;
            }
        }
    }
}
</script>


<style scoped>
.container {
    width: 100%;
    height: 100%;
    max-width: 800px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: -8px;
}
.img {
    position: absolute;
    width: 100%;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-duration: 60s;
}

.c1 {
    animation-name: roll1;
}
.c2 {
    animation-name: roll2;
}
.img_desc {
    width: 200px;
    height: 20px;
    margin-bottom: 60px;
}
.img_button {
    width: 90%;
}

.p_title {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    display: flex;
    -webkit-user-drag: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.6);
}

.contentText {
    font-size: 32px;
    color: #FFF;
    font-weight: 400;
    font-style: italic;
}
.textTop {
    margin-top: 20%;
    margin-left: -100px;
}
.textBottom {
    margin-top: -20px;
    margin-left: 100px;
}
.divGap {
    flex: 1;
}

.button {
    width: 70%;
    height: 60px;
    border-radius: 30px;
    margin-bottom: 20%;
    align-items: center;
    justify-content: center;
    display: flex;

    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-duration: 1.4s;
    animation-name: button;
}
.buttonTitle {
    font-size: 26px;
    color: #FFF;
    
}

.desc {
    font-size: 26px;
    background: linear-gradient(to right, gold, red);
    -webkit-background-clip: text;
    color: transparent;
    font-style: oblique;
}

@keyframes roll1 {
    0% { top: 0px }
    100% { top: -161% }
}
@keyframes roll2 {
    0% { top: 161% }
    100% { top: 0px }
}

@keyframes button {
    0% { width: 200px; height: 50px; }
    50% { width: 260px; height: 60px; }
    100% { width: 200px; height: 50px; }

    /* 0% { transform: translateX(-5%)}
    50% { transform: translateX(5%)}
    100% { transform: translateX(-5%)} */
}
</style>